"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsLog = exports.track = exports.page = exports.identify = exports.init = exports.environmentResolver = exports.Environments = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const jsnlog_1 = require("jsnlog");
var Environments;
(function (Environments) {
    Environments["DEV"] = "DEV";
    Environments["UAT"] = "UAT";
    Environments["PROD"] = "PROD";
    Environments["LOCAL"] = "LOCAL";
    Environments["UNKNOWN"] = "UNKNOWN";
})(Environments = exports.Environments || (exports.Environments = {}));
var Tiers;
(function (Tiers) {
    Tiers["STANDARD"] = "STANDARD";
    Tiers["BASIC"] = "BASIC";
})(Tiers || (Tiers = {}));
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 1000] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 2000] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 3000] = "INFO";
    LogLevel[LogLevel["WARN"] = 4000] = "WARN";
    LogLevel[LogLevel["ERROR"] = 5000] = "ERROR";
    LogLevel[LogLevel["FATAL"] = 6000] = "FATAL";
})(LogLevel || (LogLevel = {}));
/* Local State */
let options;
let neonUserId = '';
let tier;
let analyticsUrl;
// logging variables
let analyticSessionData;
let analyticPlatformData;
let analyticAjaxAppender;
let initiatedLogger;
let analyticsLoggerName;
/* Functions */
function environmentResolver(env) {
    if (!env) {
        return Environments.UNKNOWN;
    }
    const envUp = env.toUpperCase();
    switch (envUp) {
        case 'DEV': return Environments.DEV;
        case 'DEVELOPMENT': return Environments.DEV;
        case 'UAT': return Environments.UAT;
        case 'TEST': return Environments.UAT;
        case 'PROD': return Environments.PROD;
        case 'PRODUCTION': return Environments.PROD;
        case 'LOCAL': return Environments.LOCAL;
        case 'UNKNOWN': return Environments.UNKNOWN;
        default: return Environments.UNKNOWN;
    }
}
exports.environmentResolver = environmentResolver;
// Helper functions
const getNeonUserId = (accessToken) => {
    const decodedAccessToken = jwt_decode_1.default(accessToken);
    const neonUserIdKey = Object.keys(decodedAccessToken).filter(key => key.indexOf('/neonUserId') > -1)[0];
    return decodedAccessToken[neonUserIdKey] || decodedAccessToken.sub;
};
const getNeonUserTier = (accessToken) => {
    const decodedAccessToken = jwt_decode_1.default(accessToken);
    const tierKey = Object.keys(decodedAccessToken).filter(key => key.indexOf('/tier') > -1)[0];
    return tierKey ? decodedAccessToken[tierKey] : undefined;
};
const getIsInternal = (decodedIdToken) => {
    const internalDomains = [
        '@marexspectron.com',
        '@marex.com',
        '@rcgdirect.com'
    ];
    return !!internalDomains.filter(domain => { var _a; return ((_a = decodedIdToken.email) === null || _a === void 0 ? void 0 : _a.indexOf(domain)) > -1; }).length;
};
function assertIsInitialised(options) {
    if (!options) {
        throw new Error('neon-appcues: appcues.init() must be called before calling other functions');
    }
}
function analyticsUrlResolver(env) {
    switch (env) {
        case Environments.DEV: return 'https://dev-app.neon.markets/analytics/clientlog';
        case Environments.UAT: return 'https://uat-app.neon.markets/analytics/clientlog';
        case Environments.PROD: return 'https://app.neon.markets/analytics/clientlog';
        case Environments.LOCAL: return 'localhost:1988/analytics/clientlog';
        case Environments.UNKNOWN: return undefined;
        default: return undefined;
    }
}
const init = (initOptions) => {
    var _a, _b;
    const isAlreadyInitialised = !!options;
    options = initOptions;
    options.log('Appcues init', { appcuesAvailable: !!window.Appcues });
    neonUserId = getNeonUserId(initOptions.accessToken);
    tier = getNeonUserTier(initOptions.accessToken);
    if (initOptions.analyticOptions && initOptions.analyticOptions.recordAnalytics == true) {
        analyticsUrl = analyticsUrlResolver(initOptions.analyticOptions.env);
        analyticSessionData = initOptions.analyticOptions.sessionData;
        analyticLoggerInit();
    }
    if (!isAlreadyInitialised && (!initOptions.analyticOptions || ((_a = initOptions.analyticOptions) === null || _a === void 0 ? void 0 : _a.analyticsOnly) == false)) {
        (_b = window.Appcues) === null || _b === void 0 ? void 0 : _b.on('form_submitted', (event) => {
            assertIsInitialised(options);
            options.log('Appcues form submitted', { neonUserId, event });
        });
    }
};
exports.init = init;
const identify = (customProperties) => {
    var _a, _b;
    assertIsInitialised(options);
    const idToken = jwt_decode_1.default(options.idToken);
    const properties = Object.assign({ createdAt: idToken['http://neon.markets/created_at'], isInternal: getIsInternal(idToken), [options.appName + 'LastAccessed']: new Date(), tier }, customProperties);
    (_a = window.Appcues) === null || _a === void 0 ? void 0 : _a.identify(neonUserId, properties);
    (_b = window.Appcues) === null || _b === void 0 ? void 0 : _b.track(options.appName + 'Accessed', '');
    options.log('Appcues identify', { properties });
};
exports.identify = identify;
const page = () => {
    var _a;
    (_a = window.Appcues) === null || _a === void 0 ? void 0 : _a.page();
};
exports.page = page;
const track = (eventName, eventProperties) => {
    var _a;
    (_a = window.Appcues) === null || _a === void 0 ? void 0 : _a.track(eventName, eventProperties);
};
exports.track = track;
/* LOGGING HELPERS */
const getTimeStamp = () => new Date().toISOString();
const analyticLogObject = (data) => {
    jsnlog_1.JL(analyticsLoggerName).log(LogLevel.INFO, {
        time: getTimeStamp(),
        app: analyticSessionData === null || analyticSessionData === void 0 ? void 0 : analyticSessionData.appName,
        clientName: analyticSessionData === null || analyticSessionData === void 0 ? void 0 : analyticSessionData.appName,
        clientVersion: analyticSessionData === null || analyticSessionData === void 0 ? void 0 : analyticSessionData.appVersion,
        neonUserId,
        sessionId: analyticSessionData === null || analyticSessionData === void 0 ? void 0 : analyticSessionData.sessionId,
        type: LogLevel.INFO,
        platformData: analyticPlatformData,
        message: '',
        data
    });
    analyticAjaxAppender.sendBatch();
};
const analyticsLog = (data) => {
    try {
        analyticLogObject(data);
    }
    catch (e) {
        if (options === null || options === void 0 ? void 0 : options.log) {
            options === null || options === void 0 ? void 0 : options.log('Error logging to analytics ' + (e === null || e === void 0 ? void 0 : e.message), ({ error: e, payload: data }));
        }
    }
};
exports.analyticsLog = analyticsLog;
const analyticsGetanalyticPlatformData = () => {
    const bowser = require('bowser');
    const browser = bowser.getParser(window.navigator.userAgent);
    const cookies = window.navigator.cookieEnabled;
    const browserInfo = browser.parse();
    return {
        cookies: cookies,
        browser: browserInfo.parsedResult.browser.name,
        browserVersion: browserInfo.parsedResult.browser.version,
        os: browserInfo.parsedResult.os.name,
        osVersion: browserInfo.parsedResult.os.version,
        osName: browserInfo.parsedResult.os.versionName,
        platform: browserInfo.parsedResult.platform.type
    };
};
const analyticLoggerInit = () => {
    if (initiatedLogger) {
        return;
    }
    initiatedLogger = true;
    const analyticsAppenders = [];
    const consoleAppender = jsnlog_1.JL.createConsoleAppender('consoleAnalyticAppender');
    analyticsAppenders.push(consoleAppender);
    if (consoleAppender.setOptions) {
        consoleAppender.setOptions({ level: LogLevel.INFO, disallow: "Appcue|appcue" });
    }
    analyticAjaxAppender = jsnlog_1.JL.createAjaxAppender('ajaxAnalyticAppender');
    if (analyticAjaxAppender.setOptions) {
        analyticAjaxAppender.setOptions({
            level: LogLevel.INFO,
            url: analyticsUrl,
            batchTimeout: 2000,
            batchSize: 10,
            maxBatchSize: 100,
            disallow: "Appcue|appcue"
        });
    }
    analyticsAppenders.push(analyticAjaxAppender);
    try {
        analyticPlatformData = analyticsGetanalyticPlatformData();
    }
    catch (e) { }
    jsnlog_1.JL(analyticsLoggerName).setOptions({
        appenders: analyticsAppenders
    });
};
